import ShareAction from "../actions/ShareAction";



export default ShareAction;